import { defineMessages } from 'react-intl';

export default defineMessages({
    removeEligibility: {
        id: 'ml.quoteandbind.common.MLEmployeeEligibility.removeEligibility',
        defaultMessage: 'Reset Employee Eligibility'
    },
    employeeInformation: {
        id: 'ml.quoteandbind.common.MLEmployeeEligibility.employeeInformation',
        defaultMessage: 'Employee Information:'
    },
    employeeNumber: {
        id: 'ml.quoteandbind.common.MLEmployeeEligibility.employeeNumber',
        defaultMessage: 'Employee Number'
    },
    badgeNumber: {
        id: 'ml.quoteandbind.common.MLEmployeeEligibility.badgeNumber',
        defaultMessage: 'Badge Number'
    },
    NameInsuredField: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.NameInsuredField",
        defaultMessage: "Name Insured",
    },
    NameInsuredFieldPolChange: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.NameInsuredFieldPolChange",
        defaultMessage: "Named Insured (Select Employee Name)",
    },
    mailingAddress: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.mailingAddress",
        defaultMessage: "Mailing Address",
    },
    eligibilityFileSearchResultLabel: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.eligibilityFileSearchResultLabel",
        defaultMessage: "Eligibility File Search Results"
    },
    selectionLabel: {
        "id": "ml.quoteandbind.common.MLEmployeeEligibility.selectionLabel",
        "defaultMessage": "Select a match from the search results below with the Named Insured for the quote listed above"
    },
    name: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.name",
        defaultMessage: "Eligibility File Name"
    },
    address: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.address",
        defaultMessage: "Eligibility File Address"
    },
    manualSearchHeading: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.manualSearchHeading",
        defaultMessage: "Did not find who you are looking for? Try searching:"
    },
    zip: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.zip",
        defaultMessage: "Zip"
    },
    zipPlaceholder: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.zipPlaceholder",
        defaultMessage: "Zip Code"
    },
    lastName: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.lastName",
        defaultMessage: "and Last Name"
    },
    lastNamePalceholder: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.lastNamePalceholder",
        defaultMessage: "Last Name"
    },
    searchButton: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.searchButton",
        defaultMessage: "Search"
    },
    fileName: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.fileName",
        defaultMessage: "Eligibility File Name"
    },
    fileAddress: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.fileAddress",
        defaultMessage: "Eligibility File Address"
    },
     checkEligibilityBtnLabel: {
        id: "ml.quoteandbind.common.MLEmployeeEligibility.checkEligibilityBtnLabel",
        defaultMessage: "Check Eligibility"
    },
      requiredField: {
        id: 'ml.quoteandbind.common.MLEmployeeEligibility.requiredField',
        defaultMessage: 'This is a required field.'
    }

})